
import React from 'react';
import styled from 'styled-components';
import { themeGet } from "styled-system";
import { FormattedMessage } from "react-intl";
import { injectIntl } from "react-intl";
import CertificateAvailability from "../CertificateAvailability";
import Ects from "../Ects";

import Spacer from "../Spacer";
import Box from '../Box';

const ProfileTitle = styled.h1`
  color:#29264C;
  color:#FFFFFF;
  font-family: ${themeGet("fonts.TTNormsProBold")};
  font-style:normal;
  font-weight:bold;
  font-size:56px;
  line-height:64px;
  text-align:center;
  margin:0;
  margin-bottom:13px;
`

const CoursesContainer = styled(Box)`
  display:flex;
  flex-direction:column;
  align-items:center;
  border-top:1px solid #C4C4C4;
	border-bottom:1px solid #C4C4C4;
	margin:0 auto;
  margin-top:64px;
  padding-top:64px;
  padding-bottom:128px;
  width:100%;
  max-width:1280px;
`

const Title = styled.h1`
  lineHeight: 1.25;
  font-family: ${themeGet("fonts.TTNormsProBold")};
  color: #FFFFFF;
  font-weight: normal;
`;

const CoursesList = styled(Box)`
  display:flex;
  flex-direction:row;
  align-items:flex-start;
  max-width:100%;

  @media(max-width:1024px) {
    flex-direction:column;
  }
`

const CourseSection = styled(Box)`
  display:flex;
  flex-direction:column;
  background:#FFFFFF;
  box-shadow:0 0 16px rgba(0, 0, 0, 0.16);
  border-radius:4px;
  width:100%;
  max-width:608px;
  height:auto;
  margin:14px;
  padding:32px;
  box-sizing:border-box;

  @media(max-width:1024px) {
    margin-bottom:32px;
  }

  @media(max-width:425px) {
    margin:0;
    margin-bottom:32px;
  }

`

const CourseSectionHeader = styled(Box)`
  display:flex;
  flex-direction:row;
  border-bottom:1px solid #C4C4C4;
  padding-bottom:32px;

  img {
    min-width:128px;
    min-height:128px;
    border-radius:4px;
    margin-right:24px;
  }

  h2 {
    color:#29264C;
		font-family: ${themeGet("fonts.TTNormsProBold")};
    font-style:normal;
    font-weight:bold;
    font-size:28px;
    line-height:36px;
    margin:0;
    margin-bottom:13px;
  }

  a {
    background:#29264C;
    border:1px solid #29264C;
    box-sizing:border-box;
    border-radius:100px;
    padding:10px 16px;
    display:flex;
    flex-direction:row;
    color:#FFFFFF;
		font-family: ${themeGet("fonts.TTNormsProRegular")};
    font-style:normal;
    font-weight:500;
    font-size:14px;
    line-height:22px;
    text-align:center;
    text-decoration:none;
  }

  div {
    display:flex;
    flex-direction:column;
    justify-content:center;
    align-items:flex-start;

    @media(max-width:425px) {
      align-items:center;
    }
  }
  
  @media(max-width:425px) {
    width:100%;
    flex-direction:column;
    align-items:center;
    text-align:center;
  }
`

const CourseSectionItem = styled(Box)`
  display:flex;
  flex-direction:column;
  border-bottom:1px solid #C4C4C4;
  padding-top:32px;
  padding-bottom:32px;
  justify-content:flex-start;
  align-items:flex-start;

  h3 {
    color:#29264C;
		font-family: ${themeGet("fonts.TTNormsProBold")};
    font-style:normal;
    font-weight:bold;
    font-size:20px;
    line-height:20px;
    margin:0;
    margin-bottom:16px;

  }

  p {
		font-family: ${themeGet("fonts.TTNormsProRegular")};
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    line-height: 24px;
    color:#29264C;
    margin:0;
  }
`

/*const CourseSectionButton = styled(Box)`
  display:flex;
  flex-direction:row;
  padding: 10px 16px;
  border:1px solid #29264C;
  box-sizing: border-box;
  border-radius:100px;
  font-family: ${themeGet("fonts.walsheimMedium")};
  font-style:normal;
  font-weight:500;
  font-size:14px;
  line-height:22px;
  text-align:center;
  color:#29264C;
  text-decoration:none;
  margin-top:16px;
  cursor:pointer;
  user-select:none;
`*/

const Courses = (props) => {
  const { intl } = props;

  return (
    <div>
      <Spacer py={128} />
      <ProfileTitle>
        <FormattedMessage id="account.myProfile" />
      </ProfileTitle>
      <CoursesContainer>
        <Title>
          <FormattedMessage id="account.courses" />
        </Title>
        <CoursesList>
          <CourseSection>
            <CourseSectionHeader>
              <img src="/images/EoAI.svg" alt="Elements of AI Portrait" />
              <Box display="flex" flexDirection="column" alignItems="flex-start" justifyContent="center">
                <h2><FormattedMessage id="globals.introToAI" /></h2>
                <a href={intl.formatMessage({ id: "routes.LANDING" })}><FormattedMessage id="account.goToCourse" /> &nbsp; →</a>
              </Box>
            </CourseSectionHeader>
            {props.ects === false ?
              null
              :
              <CourseSectionItem>
                <Ects />
              </CourseSectionItem>
            }

            <CourseSectionItem>
              <h3><FormattedMessage id="account.certificate" /></h3>
              <CertificateAvailability user={props.user} />
            </CourseSectionItem>
          </CourseSection>

          <CourseSection>
            <CourseSectionHeader>
              <img src="/images/BAICourse.svg" alt="Building AI Portrait" />
              <div>
                <h2><FormattedMessage id="globals.buildingAI" /></h2>
                <a href={intl.formatMessage({ id: "routes.BUILDING_AI" })}><FormattedMessage id="account.goToCourse" /> &nbsp; →</a>
              </div>
            </CourseSectionHeader>
            <CourseSectionItem>
              <h3><FormattedMessage id="account.buildingAINew" /></h3>
              <p>
                <FormattedMessage id="section.footerEndOfTheCourseBAI" />
              </p>
            </CourseSectionItem>
          </CourseSection>
        </CoursesList>
      </CoursesContainer>
    </div>
  )
}

export default injectIntl(Courses);